import { Component, PureComponent } from 'react'
import styled from 'glamorous'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { graphql } from 'react-apollo'
import { filter, map } from 'lodash'

import { $ } from 'utils'
import { Icon, HeaderRow, PhotoListSelector, Tooltip, Loader, Button } from 'components'
import { PANEL_DESCRIPTORS } from 'queries'

import PanelSearchInput from './PanelSearchInput'

// temporary data
// const options = [1, 2, 3, 4, 5].map(el => ({ label: el, value: el }))
// const value = 5

const AnimatedContainer = styled.div({
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  background: '#fff',
  zIndex: 2,
  transform: 'translateX(100%)',
  animation: 'var(--animationSlideIn)',
}, ({ shown }) => !shown && ({
  animation: 'var(--animationSlideOut)',
}), 'AddFacesPanel')

const Container = styled.div({
  position: 'relative',
  width: '100%',
  height: '100%',
  background: 'white',
  overflow: 'hidden',
}, 'cls-container')

const MatchingContainer = styled.div({
  position: 'absolute',
  height: '100%',
  width: '100%',
}, 'cls-matchContainer')

const InputContainer = styled.div({
  marginTop: 20
})

// const SelectContainer = styled.div({
//   marginTop: 12
// })

const InnerContainer = styled(PerfectScrollbar)({
  width: '100%',
  height: '100%',
  overflowX: 'auto',
  overflowY: 'hidden',
  padding: '20px 30px',
})

const PhotosContainer = styled.div({
  marginTop: 30,
  marginLeft: -2,
})

const BottomBar = styled.div({
  position: 'relative',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: 20,
})

class PanelContainer extends PureComponent {

  // todo: need fix local offset on data.variables.offset
  // https://github.com/apollographql/apollo-client/issues/2499
  componentWillMount() {
    this.setState({ offset: this.props.data.variables.offset })
  }

  componentWillReceiveProps(nextProps) {
    const { data: { descriptors, loading }, initialSelected, targetType, targetId,
      syncMode, syncSelected, searchItems } = nextProps
    if (loading) { return }

    if (syncMode) {
      const items = searchItems.length > 0
        ? [...descriptors.items, ...filter(searchItems, s => !descriptors.items.some(d => d.uuid === s.uuid))]
        : descriptors.items
      let allAttached

      if (targetType === 'person') {
        allAttached = filter(items, descriptor =>
          descriptor.person && descriptor.person.uuid === targetId)
      } else if (targetType === 'list') {
        allAttached = filter(items, descriptor =>
          descriptor.lists.some(list => list.uuid === targetId))
      }

      if (allAttached.length > initialSelected.length) {
        const newItems = filter(allAttached, item =>
          !initialSelected.some(old => old.uuid === item.uuid))
        syncSelected(newItems)
      }
    }
  }

  fetchMore = () => {
    this.setState({ offset: this.state.offset + 1 }, () =>
      this.props.data.fetchMore({
        variables: {
          offset: this.state.offset,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev
          const newItems = [...prev.descriptors.items, ...fetchMoreResult.descriptors.items]
          return {...prev, descriptors: { ...prev.descriptors, items: newItems }}
        }
      })
    )
  }

  render = () => {
    const { data: { descriptors, loading }, handleSubmit, handleSelect, selectAllFaces,
      close, selected = [], initialSelected = [], isLock, targetId, searchItems, handleSearch } = this.props
    if (loading && !descriptors) return $(Loader)

    const photos = searchItems.length > 0 ? searchItems : (descriptors ? descriptors.items : [])
    const locked = isLock ? map(filter(photos, photo =>
        photo.person && photo.person.uuid !== targetId), p => p.uuid) : []
    const allowed = filter(photos, photo => !locked.includes(photo.uuid))
    const selectedAll = selected.length === (allowed.length) && photos.length > 0

    return (
      $(Container,
        $(MatchingContainer,
          $(InnerContainer,
            $(HeaderRow, {
                label: 'Add Faces',
                onLabelClick: close,
                clickable: true,
                withArrow: true
              },
              $(Tooltip, { tip: 'SelectAll', position: 'bottom' },
                $(Icon, {
                  type: 'selectAll',
                  isActive: selectedAll,
                  onClick: () => selectAllFaces(allowed)
                })
              ),
              $(Tooltip, { tip: 'Done' },
                $(Icon, {
                  type: 'done',
                  isDisabled: selected.length === 0 && initialSelected.length === 0,
                  isActive: selected.length > 0 || initialSelected.length > 0,
                  onClick: handleSubmit
                })
              )
            ),
            $(InputContainer, $(PanelSearchInput, { targetType: 'descriptor', onChange: handleSearch })),
            // $(SelectContainer,
            //   $(Select, {
            //     value,
            //     options,
            //     onChange: noop,
            //     width: '100%',
            //     bgColor: 'var(--white)',
            //     clearable: false,
            //     searchable: false
            //   }),
            // ),
            $(PhotosContainer,
              $(PhotoListSelector, {
                items: photos,
                selected,
                locked,
                onSelect: handleSelect,
              }),
            ),
            photos.length < descriptors.count && searchItems.length === 0 &&
            $(BottomBar,
              $(Button, {
                onClick: this.fetchMore,
                bgColor: '#9a9af2',
                primary: true,
                width: '185px',
              }, 'Show more'),
            )
          ),
        ),
      )
    )
  }
}

const options = {
  options: props => {
    return {
      fetchPolicy: 'cache-and-network',
      variables: getVariables(),
    }
  }
}
const AddFacesPanelGql = graphql(PANEL_DESCRIPTORS, options)(PanelContainer)


class AddFacesPanel extends Component {

  state = {
    selected: this.props.selected || [],
    initialSelected: this.props.selected || [],
    searchItems: [],
    shown: true
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected) {
      this.setState({selected: nextProps.selected})
    }
  }

  syncSelected = (newItems) => {
    this.setState({
      initialSelected: this.state.initialSelected.concat(newItems),
      selected: this.state.selected.concat(newItems)
    })
  }

  close = () => {
    this.setState({ shown: false })
    setTimeout(() => { this.props.onClose() }, 300)
  }

  handleSubmit = () => {
    this.props.onSubmit(this.state.selected)
    this.close()
  }

  handleSyncSubmit = () => {
    const { selected, initialSelected } = this.state
    const detach = filter(initialSelected, item =>
      !selected.some(s => s.uuid === item.uuid))
    const attach = filter(selected, s =>
      !initialSelected.some(item => item.uuid === s.uuid))
    this.props.onSubmit(detach, attach)
    this.close()
  }

  handleSelect = (face) => {
    const { selected } = this.state
    if (!selected.find(l => l.uuid === face.uuid))
      this.setState({ selected: selected.concat(face) })
    else
      this.setState({ selected: selected.filter(l => face.uuid !== l.uuid) })
  }

  selectAllFaces = (faces) => {
    this.setState({ selected: [...faces] })
  }

  handleSearch = (item) => {
    const { searchItems } = this.state
    if (!searchItems.find(s => s.uuid === item.uuid)) {
      this.setState({ searchItems: searchItems.concat(item) })
    }
  }

  render = () => {
    const { syncMode, isLock, targetType, targetId } = this.props
    const { selected, initialSelected, searchItems, shown } = this.state

    return (
      $(AnimatedContainer, { shown },
         $(AddFacesPanelGql, {
           handleSubmit: syncMode ? this.handleSyncSubmit : this.handleSubmit,
           handleSelect: this.handleSelect,
           selectAllFaces: this.selectAllFaces,
           close: this.close,
           selected,
           initialSelected,
           isLock,
           syncMode,
           targetType,
           targetId,
           syncSelected: this.syncSelected,
           searchItems,
           handleSearch: this.handleSearch
         })
      )
    )
  }
}

export default AddFacesPanel

const getVariables = (queryParams = {}) => ({
  limit: queryParams.limit || 15,
  offset: queryParams.offset || 1,
})




// WEBPACK FOOTER //
// ./src/components/panels/AddFacesPanel.js